import { render, staticRenderFns } from "./InvestigationTable.vue?vue&type=template&id=66e17360"
import script from "./InvestigationTable.vue?vue&type=script&lang=js"
export * from "./InvestigationTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports